import { Typography, TypographyProps } from '@mui/material';
import { useState } from 'react';

import { colors } from 'src/global/styles/colors';

interface ReadMoreProps {
  id: string;
  text: string;
  amountOfWords?: number;
  typoProps: TypographyProps;
}

export const ReadMore = ({ id, text, amountOfWords = 36, typoProps }: ReadMoreProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const splittedText = text.split(' ');
  const itCanOverflow = splittedText.length > amountOfWords;
  const beginText = itCanOverflow ? splittedText.slice(0, amountOfWords - 1).join(' ') : text;
  const endText = splittedText.slice(amountOfWords - 1).join(' ');

  return (
    <Typography id={id} {...typoProps}>
      {beginText}
      {itCanOverflow && (
        <>
          {!isExpanded && <span>... </span>}
          <span className={`${!isExpanded && 'hidden'}`} aria-hidden={!isExpanded}>
            {' '}
            {endText}
          </span>
          <span
            className='ml-1'
            role='button'
            tabIndex={0}
            aria-expanded={isExpanded}
            aria-controls={id}
            style={{
              fontWeight: 500,
              color: colors.blue75,
              cursor: 'pointer',
            }}
            onClick={() => setIsExpanded(!isExpanded)}>
            {isExpanded ? 'Read less' : 'Read more'}
          </span>
        </>
      )}
    </Typography>
  );
};
